import { Grid, Typography, Hidden, Paper } from '@mui/material';
import union1 from '../../assets/pictures/unia1.jpg';
import union2 from '../../assets/pictures/unia2.jpg';
import colors from '../../assets/colors';
import texts from '../../assets/texts';

export default function UESupport() {
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      component={Paper}
      sx={{ marginTop: '5vh' }}
    >
      <Grid item xs={12} sx={{ mx: 7, mt: 3 }}>
        <Typography
          variant="body2"
          align="center"
          sx={{ color: colors.oldAgroweGreen }}
        >
          {texts.copyright}
        </Typography>
      </Grid>
      <Hidden lgUp>
        <Grid
          container
          item
          xs={12}
          alignItems="center"
          justifyContent="center"
          sx={{ padding: 1 }}
        >
          <Grid
            container
            alignItems={'center'}
            justifyContent={'center'}
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
          >
            <img src={union1} alt={'UE support'} height={'50px'} />
          </Grid>
          <Grid
            container
            alignItems={'center'}
            justifyContent={'center'}
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
          >
            <img src={union2} alt={'UE support'} height={'50px'} />
          </Grid>
        </Grid>
      </Hidden>
      <Hidden lgDown>
        <Grid
          container
          item
          xs={12}
          alignItems="center"
          justifyContent="center"
          sx={{ padding: 1 }}
        >
          <Grid
            container
            alignItems={'flex-end'}
            justifyContent={'flex-end'}
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
          >
            <img src={union1} alt={'UE support'} height={'50px'} />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <img src={union2} alt={'UE support'} height={'50px'} />
          </Grid>
        </Grid>
      </Hidden>
    </Grid>
  );
}
